import React from 'react';
import PropTypes from 'prop-types';

const SimpleInput = ({ input, label, type, placeholder, disabled, onChange }) => (
  <div className="form-group">
    <label htmlFor={input.name} className="col-sm-3">
      {label}
    </label>
    <div className="col-sm-9">
      <input
        {...input}
        onChange={onChange}
        type={type}
        className="form-control"
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  </div>
);

SimpleInput.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

SimpleInput.defaultProps = {
  input: {},
  placeholder: '',
  disabled: false,
};

export default SimpleInput;



// WEBPACK FOOTER //
// ./src/components/common/SimpleInput.js